













import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { CountryTotalDataItem } from "@/classes/DistroDataSet";

/* eslint-disable @typescript-eslint/camelcase */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_material from "@amcharts/amcharts4/themes/material";
/* eslint-enable @typescript-eslint/camelcase */

am4core.useTheme(am4themes_material);

@Component
export default class TotalsMap extends Vue {
  @Prop() mapData!: CountryTotalDataItem[];

  chart?: am4maps.MapChart;

  mounted() {
    this.renderMap();
  }

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  @Watch("mapData")
  renderMap() {
    if (this.chart) {
      this.chart.dispose();
    }

    this.chart = am4core.create(
      this.$refs.totalsMap as HTMLDivElement,
      am4maps.MapChart
    );

    // Set map definition
    // eslint-disable-next-line @typescript-eslint/camelcase
    this.chart.geodata = am4geodata_worldLow;

    // Set projection
    this.chart.projection = new am4maps.projections.Miller();

    const polygonSeries = new am4maps.MapPolygonSeries();
    polygonSeries.exclude = ["AQ"];

    let maxValue = 0;
    let secondMax = 0;
    this.$props.mapData.forEach((md: CountryTotalDataItem) => {
      if (md.earningsUSD > maxValue) {
        maxValue = md.earningsUSD;
      }
      if (md.earningsUSD > secondMax && md.earningsUSD < maxValue) {
        secondMax = md.earningsUSD;
      }
    });

    polygonSeries.heatRules.push({
      property: "fill",
      target: polygonSeries.mapPolygons.template,
      maxValue: secondMax * 1.3,
      min: am4core.color("#F8BBD0"),
      max: am4core.color("#880E4F")
    });

    // polygonSeries.dataFields.id = "country";
    // polygonSeries.dataFields.value = "earningsUSD";
    polygonSeries.data = this.$props.mapData.map((md: CountryTotalDataItem) => {
      return { id: md.country, value: md.earningsUSD };
    });
    polygonSeries.useGeodata = true;

    this.chart.series.push(polygonSeries);

    // Set up heat legend
    const heatLegend = this.chart.createChild(am4maps.HeatLegend);
    heatLegend.series = polygonSeries;
    heatLegend.align = "right";
    heatLegend.valign = "bottom";
    heatLegend.width = am4core.percent(20);
    heatLegend.marginRight = am4core.percent(4);
    heatLegend.minValue = 0;
    heatLegend.maxValue = 40000000;

    // Set up custom heat map legend labels using axis ranges
    const minRange = heatLegend.valueAxis.axisRanges.create();
    minRange.value = heatLegend.minValue;
    minRange.label.text = "low";
    const maxRange = heatLegend.valueAxis.axisRanges.create();
    maxRange.value = heatLegend.maxValue;
    maxRange.label.text = "high";

    // Blank out internal heat legend value axis labels
    heatLegend.valueAxis.renderer.labels.template.adapter.add("text", () => {
      return "";
    });

    // Configure series tooltip
    const polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipText = "{name}: ${value.formatNumber('#.00')}";
    polygonTemplate.nonScalingStroke = true;
    polygonTemplate.strokeWidth = 0.5;

    // Create hover state and set alternative fill color
    const hs = polygonTemplate.states.create("hover");
    hs.properties.fill = am4core.color("#E91E63");

    // Zoom control
    this.chart.zoomControl = new am4maps.ZoomControl();
    this.chart.zoomControl.valign = "top";
  }
}
